import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { apiColletions, historyServerApiColletions, socketServerApiColletions } from "src/app/core/constants/api_collection";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class HistoryService {
  constructor(private apiService: ApiService) {}

  getRunningScheduleBookingHistoryList(parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.apiService.get({ url: apiColletions.booking, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  getBookingHistoryList(parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.apiService.get({ url: historyServerApiColletions.bookingHistory, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  getRunningBookingDetails(bookingId: string): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const url = `${apiColletions.booking}/${bookingId}`;
      this.apiService.get({ url: url }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  getBookingDetails(bookingId: string): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const url = `${historyServerApiColletions.bookingHistory}/${bookingId}`;
      this.apiService.get({ url: url }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  getBookingLocation(bookingId: string, parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const url = `${socketServerApiColletions.location}/${bookingId}`;
      this.apiService.get({ url: url, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  changeBookingStatus(bookingId: string, parameters: any): Observable<boolean> {
    return new Observable<any>((observer) => {
      const changeBookingStatusUrl = `${apiColletions.changeBookingStatus}/${bookingId}`;
      this.apiService.put({ url: changeBookingStatusUrl, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  cancelBooking(bookingId: string, parameters: any): Observable<boolean> {
    return new Observable<any>((observer) => {
      const cancelBookingUrl = `${apiColletions.cancelBooking}/${bookingId}`;
      this.apiService.put({ url: cancelBookingUrl, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  setBookingPauseState(bookingId: string, isPaused: boolean): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const bookingPauseUrl = `${apiColletions.bookingPause}/${bookingId}`;
      this.apiService.put({ url: bookingPauseUrl, parameters: { isPaused } }).subscribe({
        next: (response) => {
          observer.next(!!response?.data);
          observer.complete();
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  bookingCancellationCharge(bookingId: string, parameters: any): Observable<boolean> {
    return new Observable<any>((observer) => {
      const cancelBookingUrl = `${apiColletions.cancellationCharge}/${bookingId}`;
      this.apiService.get({ url: cancelBookingUrl, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  getExceptions(parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.apiService.get({ url: historyServerApiColletions.exception, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  getDriversOfBooking(bookingId: string): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const url = `${apiColletions.getBookingDrivers}/${bookingId}`; // Use a different API endpoint
      this.apiService.get({ url: url }).subscribe({
        next: (response) => {
          if (response?.data) {
            // Add specific logic for drivers
            observer.next(response.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  getPickersOfBooking(bookingId: string): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const url = `${apiColletions.getBookingPickers}/${bookingId}`; // Use a different API endpoint
      this.apiService.get({ url: url }).subscribe({
        next: (response) => {
          if (response?.data) {
            // Add specific logic for drivers
            observer.next(response.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }
}
